const requestCols = [
  { alias: 'publication_number' },
  { alias: 'application_num' },
  { alias: '战略新兴产业分类号' },
  { alias: 'title' },
  { alias: 'public_date' },
  { alias: 'assignees_addr' },
  { alias: 'priority_num' },
  { alias: 'patent_status' },
  { alias: 'last_legal_status' },
  { alias: 'legal_status' },
  { alias: 'publication_date' },
  { alias: 'application_date' },
  { alias: 'applicants_normal_stat' },
  { alias: 'applicants_stat' },
  { alias: 'patent_type_cn_stat' },
  { alias: 'main_cpc_num' },
  { alias: 'abstract_ab' },
  { alias: 'inventors' },
  { alias: 'assignees_normal_stat' },
  { alias: 'assignees_stat' },
  { alias: 'application_country' },
  { alias: 'country_name' },
  { alias: 'province_name' },
  { alias: 'city_name' },
  { alias: 'district_name' },
  { alias: 'abstract_ab_tag' },
  { alias: 'claims_tag' },
  { alias: 'description_tag' },
  { alias: 'priority_num' },
  { alias: 'publication_type' },
  { alias: 'agent' },
  { alias: 'agency' },
  { alias: 'applicant_addr' },
  { alias: 'description' },
  { alias: 'claims_num' },
  { alias: 'claims' },
  { alias: 'patent_duration' },
  { alias: 'expired_date' },
  { alias: 'award_sess' },
  { alias: 'award_name' },
  { alias: 'priority_date' },
  { alias: 'ipc_main_stat' },
  { alias: 'ipc_main' },
  { alias: 'ipc_la' },
  { alias: 'ipc_li' },
  { alias: 'cpc_fi' },
  { alias: 'cpc_la' },
  { alias: 'cpc_li' },
  { alias: 'loc' },
  { alias: 'icnea1_stat' },
  { alias: 'icnea2_stat' },
  { alias: 'icnea3_stat' },
  { alias: 'icnea4_stat' },
  { alias: 'family_info' },
  { alias: 'citation_info' },
  { alias: 'cited_info' },
  { alias: 'legal_event_status_json' },
  { alias: 'high_quality_score' },
  { alias: 'high_technical_score' },
  { alias: 'high_economy_score' },
  { alias: 'development_score' },
  { alias: 'patent_value_score' },
  { alias: 'quote' },
  { alias: 'sei_all_level' },
  { alias: 'sei_level_1' },
  { alias: 'sei_level_2' },
  { alias: 'lawsuit_id' },
  { alias: 'award_level' }
]
module.exports = {
  requestCols
}
